import {Component, Input, OnChanges} from '@angular/core';
import {ThingsUtil} from '../../../util/things';
import {ThingModalEvent} from "@events/ThingModalEvent";
import { ThingConfig } from '@core/thing/thingConfig';

@Component({
  selector: 'things-threshold',
  templateUrl: './threshold.component.html',
  styleUrls: ['./threshold.component.less']
})

export class ThingsThresholdComponent implements OnChanges {

  @Input()
  thing: any;
  isTimeBased: boolean = false;
  config: ThingConfig;
  @Input()
  isDetails: boolean = false;

  public cols: Array<any> = [];

  constructor(private thingsUtil: ThingsUtil, private thingUpdateEvent : ThingModalEvent) {
    this.thingUpdateEvent.on().subscribe(updatedThing => {
      if (updatedThing.key == "thing.update"
        && this.thing && updatedThing && updatedThing.thing && this.thing.thingId == updatedThing.thing.thingId) {
        // refresh this threshold component when this thing changes
        this.refreshThresholds();
      }
    });

    this.refreshThresholds();
  }

  ngOnChanges() {
    this.refreshThresholds();
  }

  refreshThresholds() {
    let thresholdConfig = (this.thing && this.thing.thresholdConfig) || [];

    this.cols = this.chunk(thresholdConfig, 3);
    if (this.isDetails && this.thing) {
      this.isTimeBased = this.thingsUtil.isRestroom(this.thing) || this.thingsUtil.isTimeBasedTask(this.thing);
      if (this.isTimeBased) {
        this.config = this.thingsUtil.getConfig(this.thing);
      }
    }
  }

  chunk(threshold, size) {
    let chunkArray = [];
    if (threshold && threshold.length) {
      for (let i = 0; i < threshold.length; i += size) {
        chunkArray.push(threshold.slice(i, i + size));
      }
    }

    return chunkArray;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/threshold/threshold.component.ts